import React from 'react';

const ErrorIcon = ({ size = 74, fillColor = '#FC2E20' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 73 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.36 54.75L36.5 41.61L49.64 54.75L54.75 49.64L41.61 36.5L54.75 23.36L49.64 18.25L36.5 31.39L23.36 18.25L18.25 23.36L31.39 36.5L18.25 49.64L23.36 54.75ZM36.5 73C31.4508 73 26.7058 72.0419 22.265 70.1256C17.8242 68.2094 13.9613 65.6088 10.6763 62.3238C7.39125 59.0388 4.79063 55.1758 2.87438 50.735C0.958125 46.2942 0 41.5492 0 36.5C0 31.4508 0.958125 26.7058 2.87438 22.265C4.79063 17.8242 7.39125 13.9613 10.6763 10.6763C13.9613 7.39125 17.8242 4.79063 22.265 2.87438C26.7058 0.958125 31.4508 0 36.5 0C41.5492 0 46.2942 0.958125 50.735 2.87438C55.1758 4.79063 59.0388 7.39125 62.3238 10.6763C65.6088 13.9613 68.2094 17.8242 70.1256 22.265C72.0419 26.7058 73 31.4508 73 36.5C73 41.5492 72.0419 46.2942 70.1256 50.735C68.2094 55.1758 65.6088 59.0388 62.3238 62.3238C59.0388 65.6088 55.1758 68.2094 50.735 70.1256C46.2942 72.0419 41.5492 73 36.5 73ZM36.5 65.7C44.6517 65.7 51.5563 62.8713 57.2138 57.2138C62.8713 51.5563 65.7 44.6517 65.7 36.5C65.7 28.3483 62.8713 21.4438 57.2138 15.7863C51.5563 10.1288 44.6517 7.3 36.5 7.3C28.3483 7.3 21.4438 10.1288 15.7863 15.7863C10.1288 21.4438 7.3 28.3483 7.3 36.5C7.3 44.6517 10.1288 51.5563 15.7863 57.2138C21.4438 62.8713 28.3483 65.7 36.5 65.7Z"
      fill={fillColor}
    />
  </svg>
);

export default ErrorIcon;
